import { useParams } from '@/lib/router';
import { InvestmentDetailView } from '@/components/InvestmentDetailView';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';

export default function InvestmentDetailPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <InvestmentDetailView investmentId={id!} />
    </>
  );
}
